// Lee los .tf (y los terraform.tfstate, si estan) de una carpeta elegida en el navegador (input webkitdirectory), con su ruta relativa para que el
// backend separe las capas. Ignora .terraform, .git y node_modules. Devuelve { archivos, error }.
const MAX_BYTES = 4 * 1024 * 1024;

export const leerCarpetaTf = async (fileList) => {
    const files = Array.from(fileList || []).filter(f => /\.(tf|tfstate)$/i.test(f.name) && !/(^|\/)(\.terraform|\.git|node_modules)\//.test(f.webkitRelativePath || ""));
    if (!files.length) return { archivos: [], error: "No se encontraron archivos .tf ni .tfstate en esa carpeta." };
    if (files.reduce((a, f) => a + f.size, 0) > MAX_BYTES) return { archivos: [], error: "Los archivos superan 4 MB. Elige una carpeta con menos archivos." };
    const archivos = await Promise.all(files.map(f => f.text().then(contenido => ({ nombre: f.webkitRelativePath || f.name, contenido }))));
    return { archivos, raiz: (files[0].webkitRelativePath || "").split("/")[0], error: "" };
};

// Atributos para que un <input type="file"> elija carpetas.
export const refCarpeta = (el) => { if (el) { el.setAttribute("webkitdirectory", ""); el.setAttribute("directory", ""); } };
